export default {
  reportsMissingFiles: {
    temporalCharacterization:
      "Temporal characterization file is not found. Please make sure it exists within the current release folder then try again",
    feasibility: "Requested files not found",
    networkPerformance:
      "Network performance file is not found. Please make sure it exists within the data directory then try again",
    networkDiversityReport: "Requested files not found",
    networkUnmappedSourceCodes: "Requested files not found",
    networkConcept: "Requested files not found",
    networkDataQuality: "Requested files not found",
    cohorts: "Requested files not found",
    cohortReport: "Requested files not found",
    dataStrandReport: "Requested files not found",
    population: "No files found across all data sources",
    concept: "Seems like the data file for that particular concept is missing.",
    dataQuality: "Requested files not found",
    death: "Requested files not found",
    dataDensity: "Requested files not found",
    domainTable: "Requested files not found",
    metadata: "Requested files not found",
    observationPeriod: "Requested files not found",
    performance: "Requested files not found",
    person: "Requested files not found",
    unmappedSourceCodes: "Requested files not found",
    dataQualityHistory: "Requested files not found",
    domainContinuity: "Requested files not found",
    sourceConceptOverlay: "Requested files not found",
    index: "Index file is missing. Please run AresIndexer then try again",
    location:
      "Location data is not available. Please run the latest version of achilles then try again",
    costDrilldown: "Cost information not available for this data source.",
    costTable: "Cost information not available for this data source",
  },
  technicalError: {
    codeError:
      "Something went wrong. Please submit an issue on Github and describe the steps to reproduce it",
    networkError:
      "It seems that the server is not available at this time. Please make sure you have internet connection" +
      " and the server is running then reload the page",
  },
  webApiErrors: {
    404: "Resource is not found",
    500: "Internal server error",
    403: "You don't have permission for this action",
  },
};
